import { render } from "./add-supplier.vue?vue&type=template&id=49954f74"
import script from "./add-supplier.vue?vue&type=script&lang=js"
export * from "./add-supplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__